

export const HeaderTitle:React.FC<{titleText:string}> = ({titleText}) => {
    return (
        <div className="page-hero">
            <div className="container">
                <h1>{titleText}</h1>
            </div>
        </div>
    )
}
